<template>
    <v-app>
        <v-main>
            <FormApp></FormApp>
        </v-main>
    </v-app>
</template>

<script>
import FormApp from './components/Form'

export default {
    name : 'App',
    components : {
        FormApp
    },
}
</script>

<style lang="scss" scoped>
h1 {
    font-weight: 700;
}

h2, h3 {
    font-weight: 600;
}

#aid-iframe {
    width: 100%;
    margin-top: 60px;
    height: 300px;
    opacity: 0;
    border: 0;
    overflow: auto;
}

#aid-iframe.loaded {
    opacity: 1;
}

.frame-wrap {
    position: relative;
}

.loader {
    position: absolute;
    top: 200px;
    right: 50%;
    transform: translateX(50%);
}

.loader:before {
    content: "";
    display: block;
    width: 55px;
    height: 55px;
    border: 5px solid #0167b1;
    border-top-color: transparent;
    border-radius: 50%;
    animation: loader-rotate 0.5s linear 0s infinite forwards;
}

@keyframes loader-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

#aid-iframe.loaded + .loader {
    display: none;
}
</style>